import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './header';
import Footer from './footer';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

function Cat() {
  const [allcats, setAllcats] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    getServercats();
  }, []);

  const getServercats = async () => {
    const data = new FormData();

    data.append("child_limit", "12");

    axios({
      method: 'post',
      url: '/mainsite/cat_set_by_market.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((s) => {
        setAllcats(s.data);
        console.log(s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  // Filter categories based on search query, applied to child categories only if parent doesn't match
  const filteredCategories = allcats.filter((v) => {
    const parentMatch = v.title.toLowerCase().includes(searchQuery.toLowerCase());

    // If parent matches search, don't filter its children, else apply search to children
    const childMatch = v.child && v.child.some((item) => item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase()));
    
    return parentMatch || childMatch;
  });

  return (
    <div className="bg-home9">
      <Header />

      {/* Fixed Search Bar */}
      <div
        className="container category-search-bar pt-3"
        style={{
          position: 'sticky',
          top: '80px', // Adjust based on the height of your navigation bar
          zIndex: 998,
        }}
      >
        <div className="row">
        <input
          type="text"
          className="form-control"
          placeholder="Search categories..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '10px',
            boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
          }}
        />
        </div>
      </div>

      {/* Categories Section */}
      <section className="section-box pt-40 bg-home9">
        <div className="container">
          <div className="row">
            {filteredCategories.length > 0 ? (
              filteredCategories.map((v, i) => (
                v.child && v.child.length > 0 && (
                  <div key={i} className="col-12 px-0 mb-4">
                    <div
                      style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '16px 16px 0 0',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                        overflow: 'hidden',
                      }}
                    >
                      {/* Title + Image + See All */}
                      <div
                        className="d-flex justify-content-between align-items-center px-4 pb-3"
                        style={{ backgroundColor: '#D6EFF2' }}
                      >
                        <div className="d-flex align-items-center">
                        <div style={{ fontSize: "70px", marginBottom: "0px", marginRight: "10px", color: "#4f97a1" }}>
                <i className={`fas ${v.icon}`} />
              </div>
                          <h4 style={{ marginTop: '20px' }} className="mb-0 text-dark">
                            {v.title}
                          </h4>
                        </div>
                        <Link
                          to={'/sub/' + v.bread_crumbs}
                          className="btn btn-primary"
                          onClick={() => localStorage.setItem('title', v.title)}
                          style={{
                            backgroundColor: '#2C99A1',
                            borderColor: '#2C99A1',
                            padding: '6px 14px',
                            borderRadius: '20px',
                            marginTop: '20px',
                          }}
                        >
                          See All
                        </Link>
                      </div>

                      {/* Child Categories */}
                      <div className="row p-4">
                        {v.child
                          .filter((item) => item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase()))
                          .map((item, idx) => (
                            <div key={idx} className="col-6 col-md-4 col-lg-2 mb-4">
                              <Link
                                to={
                                  v.code === 'sub'
                                    ? '/sub/' + item.bread_crumbs
                                    : 'product?id=' + item.id + '&s=' + item.name
                                }
                                onClick={() => localStorage.setItem('title', item.title)}
                                className="text-decoration-none"
                              >
                                <div
                                  className="custom-card text-center h-100"
                                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
                                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                >
                                  <div className="card-img-wrapper">
                                    <img
                                      src={item.image_path || item.img}
                                      alt={item.title}
                                      className="card-img-top"
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </div>

                                  <h6 className="mt-3 my-2 mx-2 text-dark fw-semibold">{item.title}</h6>
                                  {v.code !== 'sub' && (
                                    <Button variant="primary" size="sm" className="mt-2">
                                      {window.quote}
                                    </Button>
                                  )}
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                )
              ))
            ) : (
              <div className="col-12 text-center">
                <h5>No categories found matching your search criteria.</h5>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Cat;
